import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {UserEditCard} from './components/UserEditCard'
import {UpdatePasswordCard} from './components/UpdatePasswordCard'
import {RootState} from '../../../../../redux/store'
import {useCleanSuccessMessageHook} from '../../../../../helpers/hooks/useCleanSuccessMessageHook'
import {TitleCard} from '../../../../../helpers/elements/card/TitleCard'
import CustomMessage from '../../../../../libs/_fri/components/CustomMessage'
import {cleanSuccessMessage} from '../../../../../redux/slices/messageSlice'

export const ProfileEdit = () => {
  const successMessage = useSelector((state: RootState) => state.messageRedux)
  const cleanSuccessMessageHook = useCleanSuccessMessageHook()
  const dispatch = useDispatch()
  return (
    <>
      <div>
        <CustomMessage
          title={successMessage.title}
          description={successMessage.description}
          messageType={successMessage.messageType}
          displayType={successMessage.displayType}
          close={() => {
            dispatch(cleanSuccessMessage())
          }}
        />
      </div>
      <div className='pb-3 ps-1'>
        <TitleCard title='Editar perfil' subtitle='' />
      </div>
      <UserEditCard />
      <UpdatePasswordCard />
    </>
  )
}
